import i18n from '@dms/i18n';

export const checkoutProfileOptions = {
  payments: () =>
    [
      {value: 'CASH', label: i18n.t('entity.checkout.labels.paymentMethods.cash')},
      {value: 'CARD', label: i18n.t('entity.checkout.labels.paymentMethods.card')},
      {value: 'BANK_TRANSFER', label: i18n.t('entity.checkout.labels.paymentMethods.bankTransfer')},
      {value: 'CASH_ON_DELIVERY', label: i18n.t('entity.invoice.paymentMethod.cashOnDelivery')},
    ] as const,
  documents: () => ({
    INVOICE: i18n.t('entity.checkout.labels.invoice'),
    CORRECTIVE_INVOICE: i18n.t('entity.checkout.labels.correctiveInvoice'),
    DEPOSIT_INVOICE: i18n.t('entity.checkout.labels.depositInvoice'),
    TAX_DOCUMENT: i18n.t('entity.accounting.labels.taxDocument'),
    CORRECTIVE_TAX_DOCUMENT: i18n.t('entity.checkout.labels.correctiveTaxDocument'),
  }),
  regimes: () =>
    [
      {
        value: 'DOMESTIC',
        label: i18n.t('entity.checkout.labels.domestic'),
      },
      {value: 'IN_EUROPE', label: i18n.t('entity.checkout.labels.abroadSaleEU')},
      {value: 'OUT_OF_EUROPE', label: i18n.t('entity.checkout.labels.abroadSaleOutsideEU')},
    ] as const,
};
